import * as React from "react";
import Box from "@mui/material/Box";
import "./Home.css";
import Header from "../../shared/Header/Header";
import PatientsComponent from "../PatientManagement/PatientManagement";
import UserComponent from "../UserManagement/UserManagement";
import ServicesComponent from "../ServiceManagement/ServiceManagement";
import BranchComponent from "../BranchManagement/BranchManagement";
import SettingsComponent from "../SettingsManagement/SettingManagement";
import InvoiceManagement from "../InvoiceManagement/InvoiceManagement";
import DashboardWrapper from "../DashboardManagement/DashboardWrapper";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Routes, Route, useLocation } from "react-router-dom";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import ShareLocationOutlinedIcon from "@mui/icons-material/ShareLocationOutlined";
import PersonalInjuryOutlinedIcon from "@mui/icons-material/PersonalInjuryOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../slice/userDetailsSlice";
import api from "../../services/api";

export default function BasicTabs() {
  const location = useLocation();
  const [therapyPlans, setTherapyPlans] = React.useState([]);
  let accessToken = useSelector((state) => state.auth.accessToken);
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.userDetails.detail);

  const tabs = [
    { label: "Dashboard", icon: <GridViewIcon />, path: "/dashboard" },
    { label: "Branch", icon: <ShareLocationOutlinedIcon />, path: "/branch" },
    { label: "Services", icon: <ManageAccountsOutlinedIcon />, path: "/services" },
    { label: "Patients", icon: <PersonalInjuryOutlinedIcon />, path: "/patients" },
    { label: "Users", icon: <PersonOutlineOutlinedIcon />, path: "/users" },
    { label: "Invoice", icon: <FileCopyOutlinedIcon />, path: "/invoices" },
    { label: "Settings", icon: <SettingsOutlinedIcon />, path: "/settings" },
  ];

  React.useEffect(() => {
    if (!accessToken) {
      console.log("⏳ Waiting for access token before calling userDetails");
      return;
    }
    const fetchData = async () => {
      try {
        const details = await userDetails();
        if (details?.branches?.length > 0) {
          // await patientTherapyRecord(details.branches[0].id);
        }
      } catch (e) {
        console.error("One of the data fetching functions failed:", e);
      }
    };
    fetchData();
  }, [accessToken]);

  const userDetails = async () => {
    try {
      let getUserDetails = await api.get("app/user/current_user");
      dispatch(setUser(getUserDetails?.data));
    } catch (error) {
      console.error("Unexpected error:", error);
    }
  };

  const roleTabs = {
    admin: ["Dashboard", "Branch", "Services", "Patients", "Users", "Settings", "Invoice"],
    receptionist: ["Dashboard", "Patients", "Invoice", "Settings"],
    director: ["Dashboard", "Services", "Patients", "Invoice", "Settings"],
  };

  const role = userDetail?.role;
  const allowedLabels = role ? roleTabs[role] || [] : [];
  const visibleTabs = tabs.filter((tab) => allowedLabels.includes(tab.label));

  const patientTherapyRecord = async (id) => {
    try {
      let therapyPlans = await api.get(
        `app/patient/therapy_plans/?branch_id=${id}&filter_by_today=true`
      );
      const rawData = therapyPlans?.data || [];
      const flattenedData = flattenPatientServices(rawData);
      setTherapyPlans(flattenedData);
    } catch (error) {
      console.error("Error fetching therapy records:", error);
    }
  };

  const flattenPatientServices = (data) => {
    const dayShortMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  
    const flattened = [];
  
    data.forEach((patient) => {
      const { patient_id, patient_name, profile_pic_path, services } = patient;
  
      Object.entries(services).forEach(([_, serviceData]) => {
  
        // 🔥 Extract therapy_days from schedules
        const therapy_days = serviceData?.schedules
        ?.map((s) => s.day_of_week)        // 👉 get numbers first
        .sort((a, b) => a - b)             // 👉 sort numerically
        .map((d) => dayShortMap[d])        // 👉 then map to names
        .join(", ");
  
        flattened.push({
          patient_id,
          patient_name,
          profile_pic_path,
          ...serviceData,
          therapy_days, // ✅ add this
        });
      });
    });
  
    return flattened;
  };

  // Determine active tab based on location
  const getActiveClass = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + "/")
      ? "active"
      : "";
  };

  return (
    <Box className="app-wrapper">
      <Header userDetail={userDetail} />
      <Box className="body">
        {role ? (
          <>
            <Box className="side_menu">
              {visibleTabs.map((tab, index) => (
                <Link
                  key={index}
                  component={RouterLink}
                  to={tab.path}
                  underline="none"
                  className={`sidebar-link ${getActiveClass(tab.path)}`}
                >
                  <span className="sidebar-icon">{tab.icon}</span>
                  {tab.label}
                </Link>
              ))}
            </Box>

            {/* Content */}
            <Box className="content-area">
              <Routes>
                <Route
                  path="/dashboard"
                  element={
                    <DashboardWrapper
                      userDetail={userDetail}
                      therapyPlans={therapyPlans}
                      patientTherapyRecord={patientTherapyRecord}
                    />
                  }
                />
                <Route path="/branch" element={<BranchComponent />} />
                <Route path="/services" element={<ServicesComponent />} />
                <Route
                  path="/patients"
                  element={<PatientsComponent userDetail={userDetail} />}
                />
                <Route path="/users" element={<UserComponent />} />
                <Route path="/invoices" element={<InvoiceManagement />} />
                <Route
                  path="/settings"
                  element={<SettingsComponent userDetail={userDetail} />}
                />
                <Route
                  path="/"
                  element={
                    <DashboardWrapper
                      userDetail={userDetail}
                      therapyPlans={therapyPlans}
                      patientTherapyRecord={patientTherapyRecord}
                    />
                  }
                />
                <Route path="*" element={<div>404 - Not Found</div>} />
              </Routes>
            </Box>
          </>
        ) : (
          <Box className="loading">
            <CircularProgress color="secondary" />
          </Box>
        )}
      </Box>
    </Box>
  );
}